import type { TrustedHtml } from "@indietabletop/appkit";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { useLocation } from "wouter";
import { vars } from "../../vars.css.ts";
import { content, contract } from "./style.css.ts";

// TODO (Phase 4): Move to Appkit
export function RichText(props: { trustedHtml: TrustedHtml }) {
  const [_, navigate] = useLocation();

  return (
    <div
      className={content}
      style={assignInlineVars(contract, {
        headingFont: vars.fonts.superNormal,
        bodyFont: vars.fonts.myriad,
        emphasisFont: vars.fonts.lacquer,
      })}
      dangerouslySetInnerHTML={{ __html: props.trustedHtml }}
      onClick={(event) => {
        if (!(event.target instanceof HTMLElement)) {
          return;
        }

        const anchor = event.target.closest("a");
        if (!anchor) {
          return;
        }

        // The actual value in the HTML
        const href = anchor.getAttribute("href");
        if (!href) {
          return;
        }

        if (href.startsWith("#")) {
          return;
        }

        if (href.startsWith("/")) {
          event.preventDefault();
          event.stopPropagation();
          navigate(`~${href}`);
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        const tempLink = document.createElement("a");
        tempLink.href = anchor.href;
        tempLink.target = "_blank";
        tempLink.rel = "noopener noreferrer";
        tempLink.click();
      }}
    />
  );
}
